<template>
    <KvButton :variant="variant" :prepend-icon="copied ? successIcon : copyIcon" @click="copy">
        {{ copied ? resolvedSuccessText : resolvedText }}
    </KvButton>
</template>

<script>
import KvButton from "@/components/form/kv-button.vue";

export default {
    name: 'KvCopyButton',
    components: {
        KvButton
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        successText: {
            type: String,
            default: '',
        },
        copyIcon: {
            type: String,
            default: 'ui-copy-03',
        },
        successIcon: {
            type: String,
            default: 'ui-check',
        },
        variant: {
            type: String,
            default: 'outlined',
        },
        resetDelay: {
            type: Number,
            default: 2000,
        },
    },

    data() {
        return {
            copied: false,
            timeoutId: null,
        };
    },

    beforeUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    },

    methods: {
        async copy() {
            if (!this.value) return;

            try {
                await navigator.clipboard.writeText(this.value);

                this.copied = true;
                this.$emit('copied', this.value);

                this.timeoutId = setTimeout(() => {
                    this.copied = false;
                }, this.resetDelay);
            } catch (err) {
                console.error(this.t('copy_button-copy_failed'), err);
                this.$emit('error', err);
            }
        },
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    computed: {
        resolvedText() {
            return this.text || this.t('copy_button-copy');
        },
        resolvedSuccessText() {
            return this.successText || this.t('copy_button-copied');
        },
    },
};
</script>
